import featured1 from 'common/tp-featured1.svg'
import featured2 from 'common/tp-featured2.svg'
import featured3 from 'common/tp-featured3.svg'
import featured4 from 'common/tp-featured4.svg'
import featured5 from 'common/tp-featured5.svg'
import featured6 from 'common/tp-featured6.svg'
import featured7 from 'common/tp-featured7.svg'
import featured8 from 'common/tp-featured8.svg'
import featured9 from 'common/tp-featured9.svg'

export const CAROUSEL_WIDTH = 1300
export const CAROUSEL_SLIDE_WIDTH = 614

const slidesPerView =
  1 + (CAROUSEL_WIDTH - CAROUSEL_SLIDE_WIDTH) / CAROUSEL_SLIDE_WIDTH

export const SWIPER_CONFIG = {
  slidesPerView: slidesPerView,
  spaceBetween: 0,
  speed: 500,
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 1,
  breakpoints: {
    768: {
      slidesPerView: 1
    }
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  lazy: {
    loadPrevNext: true
  },
  pagination: {
    el: '.tp-Carousel_Pagination',
    clickable: true
  },
  navigation: {
    prevEl: '.tp-Carousel_Button-prev',
    nextEl: '.tp-Carousel_Button-next'
  }
}

export const TOP_PAGE_FEATURED = [
  {
    title: '展示会やイベント向けのノベルティ',
    banner: featured1,
    content: '大型の展示会やイベントでは、「クリアファイル」、「トートバッグ」が定番のノベルティです。携帯性に優れる「ミニステンレスボトル」や「ラベルウォーター」も人気です。',
    link: '/cms/categories/novelty/exhibition/',
    created: '2022/06/09'
  },{
    title: 'オープンキャンパス用のノベルティ',
    banner: featured2,
    content: 'オープンキャンパス中のメモ入れにも利用できる「ボールペン」や、資料整理用の「クリアファイル」、「トートバッグ」が人気です。「USBメモリ」にも学校名や団体名をプリントできます。',
    link: '/cms/categories/novelty/open-campus/',
    created: '2021/06/09'
  },{
    title: '人気のノベルティ',
    banner: featured3,
    content: 'ラクスルでの売れ筋の人気のノベルティを、主要カテゴリー別にランキング形式でご紹介いたします。人気のカテゴリーは「トートバッグ」、「Tシャツ」、「タオル」、「マスク」で、多くのノベルティ・販促品や記念品をご制作いただいております。',
    link: '/cms/categories/novelty/ranking/',
    created: '2022/11/10'
  },{
    title: '周年記念品や創立記念品向けのノベルティ',
    banner: featured4,
    content: '社名や団体名を印刷した「ステンレスタンブラー」や「ギフトカード」が周年記念品や創立記念品として人気です。職場で使える「マウスパッド」や「モバイルバッテリー」にもオリジナルデザインを印刷してご活用いただけます。',
    link: 'cms/categories/novelty/anniversary/',
    created: '2021/06/27'
  },{
    title: '卒業記念品向けのノベルティ',
    banner: featured5,
    content: '小学校・中学校・高校・大学の学校名やクラス名を印刷した「タンブラー」「マグカップ」「巾着袋」などが卒業記念品の定番です。ユニークな例だと、出先でスマートフォンなどを充電できる「モバイルバッテリー」にも名入れをして記念品として活用できます。',
    link: '/cms/categories/novelty/graduation-anniversary-gift/',
    created: '2021/06/09'
  },{
    title: '卒園記念品向けのノベルティ',
    banner: featured6,
    content: '幼稚園などの園名を印刷した「マスクケース」や「巾着袋」が卒園記念品として人気です。オリジナルデザインを施した「プリングルズ」や「小枝」などのお菓子も制作いただけます。',
    link: '/cms/categories/novelty/kindergarten-graduation-memorial/',
    created: '2021/06/09'
  },{
    title: '会社説明会など就活生へ配るノベルティ',
    banner: featured7,
    content: '社名を印刷した「マスク」「マスクケース」「巾着袋」などの日用品が人気です。スマートフォンなどの充電に対応した「モバイルバッテリー」などもノベルティとしてご活用いただけます。',
    link: '/cms/categories/novelty/career-fair/',
    created: '2021/06/09'
  },{
    title: '冬におすすめノベルティ',
    banner: featured8,
    content: '寒い冬に贈るノベルティは実用的であたたまるアイテムが喜ばれます。「ブランケット」や「ネックウォーマー」「パーカー」などの防寒グッズがおすすめです。また温かい飲み物を飲む機会も増えるため「サーモタンブラー」「マグカップ」も人気です。',
    link: 'cms/categories/novelty/winter/',
    created: '2021/06/09'
  },{
    title: '高級感のあるノベルティ',
    banner: featured9,
    content: '名入れができる「モバイルバッテリー」や「サーモステンレスボトル」、「真空断熱タンブラー」など、ラクスルの取り扱いのうち比較的単価が高い商品をまとめました。',
    link: 'cms/categories/novelty/luxury-company/',
    created: '2021/06/09'
  }
]

export const TOP_PAGE_NOVELTIES = [{
  title: 'ノベルティの価格や納期が一目瞭然',
  content: '画面上で商品や仕様、デザインの追加やオプションの有無による価格と納期がひと目で分かります。'
}, {
  title: 'WEB上でノベルティの発注が完結します',
  content: '商品選びやデザイン作成、データ入稿、見積もりの発行まで24時間WEB上で受付します。デザイン制作ソフトがなくても社名などの文字データはサイト上で入力できます。'
}]

export const TOP_PAGE_FAQ = [{
  title: 'デザイン編集ツールの仕組みを教えてください',
  content: 'ウェブサイト上で簡単にデザインデータを作れるツールです。企業やサービスのロゴ画像をお持ちの場合はツール上でアップロードして配置を決めるだけでデザインが作成可能です。画像がない場合でもテキスト入力で名入れデザインを作れます。'
},{
  title: 'サンプル印刷はどんなサービスですか？',
  content: '大部数で高額商品の発注が不安なお客様向けに、サンプルを制作できるサービスです。実物を確認して本発注ができるので、初めてのネット注文でも安心してご利用いただけます。さらに版を使う印刷を利用される場合は本発注時に版代が割引かれます。'
},{
  title: '出荷日・納品日を早めることは可能でしょうか？',
  content: '誠に申し訳ございません。サイト上の表示が最短です。今後さらに短い納期で商品をご注文いただけるよう改善を進めてまいります。'
}]
